import React, { useState, useRef } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import api from './../../service/api';

export default function CreateSupplier(props) {
    var emptySupplier = {
        name: '',
        document_number: '',
        phone: '',
        address: ''
    }

    const {
        visible,
        handleCancel,
        onCreate
    } = props;

    const [supplier, setSupplier] = useState({...emptySupplier});
    const [submitted, setSubmitted] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const toast = useRef(null);

    const onInputChange = (e, name) => {
        const val = e.value || (e.target && e.target.value) || '';
        let _supplier = { ...supplier };
        _supplier[`${name}`] = val;

        setSupplier(_supplier);
    }

    const onHide = () => {
        setSupplier({...emptySupplier});
        if(typeof handleCancel === 'function') handleCancel();
    }

    return (
        <>
            <Toast ref={toast} />
            <Dialog visible={visible} style={{ width: '450px' }} header="Novo Fornecedor" modal className="p-fluid" footer={() => {
                return(
                    <>
                        <Button label="Cancelar" disabled={disabled} icon="pi pi-times" className="p-button-text" onClick={onHide} />
                        <Button label="Salvar" onClick={() => {
                            if(!supplier.name) return setSubmitted(true);

                            setDisabled(true);
                            api().post('/supplier/create', {...supplier}).then(response => {
                                setDisabled(false);
                                if(response.status === 200 && response.data.result){
                                    toast.current.show({severity: 'success', summary: 'Sucesso', detail: response.data.message});
                                } else {
                                    toast.current.show({severity: 'warn', summary: 'Atenção', detail: response.data.message});
                                }
                                if(typeof onCreate === 'function')
                                    onCreate(response.data);
                            });

                        }} loading={disabled} icon="pi pi-check" className="p-button-text"  />
                    </>
                );
            }} onHide={onHide}>
                            
                <div className="field">
                    <label htmlFor="name">Nome</label>
                    <InputText disabled={disabled} id="name" value={supplier.name} onChange={(e) => onInputChange(e, 'name')} required autoFocus />
                    {submitted && !supplier.name && <small className="p-invalid p-error">Este campo é obrigatório.</small>}
                </div>

                <div className="formgrid grid">
                    <div className="field col">
                        <label htmlFor="document_number">CPF / CNPJ</label>
                        <InputText disabled={disabled} id="document_number" value={supplier.document_number} onChange={(e) => onInputChange(e, 'document_number')}  />
                    </div>
                </div>

                <div className="field">
                    <label htmlFor="phone">Telefone</label>
                    <InputText disabled={disabled} id="phone" value={supplier.phone} onChange={(e) => onInputChange(e, 'phone')} />
                </div>

                <div className="field">
                    <label htmlFor="address">Endereço</label>
                    <InputText disabled={disabled} id="address" value={supplier.address} onChange={(e) => onInputChange(e, 'address')} />
                </div>
            </Dialog>
        </>
    );
}